import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Inv No.', 'INVOICEREF', true, 'desc', 'left'),
  new TableColumn('Inv Type', 'INVOICETYPE', true, 'desc', 'left'),
  new TableColumn('Inv Date', 'INVOICEDATE', true, 'asc', 'left'),
  new TableColumn('Amount Incl. GST', 'TOTALINCGST', true, 'asc', 'right'),
  new TableColumn('Customer', 'CUSTOMERNAME', true, 'asc', 'left'),
  new TableColumn('Contact', 'CONTACTNAME', true, 'asc', 'center'),
  new TableColumn('Quote No', 'QUOTENO', true, 'asc', 'center'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export { Columns }
